export default "__VITE_ASSET__41e8ed12__"